import { MaskLine, Reveal } from "./Motion";

// Grid 3x3 inspirado no folder oficial · micro-label dourado + anfitrião com avatar
const WORKSHOPS = [
  {
    title: "Do problema ao ETP: construindo uma contratação a partir da necessidade real com o uso da IA",
    host: "Gustavo Shiefler",
    photo: "/speakers/gustavo-shiefler.webp",
  },
  {
    title: "O processo sob suspeita: encontre os problemas antes que o controle encontre",
    host: "Felipe Dalenogare",
    photo: "/speakers/felipe-dalenogare.webp",
  },
  {
    title: "O gabinete da contratação: você é o gestor. O problema chegou na sua mesa.",
    host: "Lara Brainer",
    photo: "/speakers/lara-brainer.webp",
  },
  {
    title: "A habilitação sem pegadinhas: atestados, qualificação técnica, diligência, saneamento e análise documental na prática com o uso da IA",
    host: "Antonio Netto",
    photo: "/speakers/antonio-netto.webp",
  },
  {
    title: "O processo de responsabilização: do fato à decisão, como construir e conduzir um processo sancionador",
    host: "Rafael Oliveira",
    photo: "/speakers/rafael-oliveira.webp",
  },
  {
    title: "O jurídico na sala de contratação: quando a solução parece simples, mas o Direito complica",
    host: "Marilene Matos",
    photo: "/speakers/marilene-matos.webp",
  },
  {
    title: "A contratação direta na mesa: você recebeu o processo. Contrata ou devolve?",
    host: "Joel de Menezes",
    photo: "/speakers/joel-niebuhr.webp",
  },
  {
    title: "Gestão de contratos: o contrato começa quando a licitação termina. Como a IA pode ajudar nos desafios",
    host: "Jader Esteves",
    photo: "/speakers/jader-esteves.webp",
  },
  {
    title: "Lei 13.303 na prática: os desafios das contratações nas empresas estatais",
    host: "Anfitrião a definir",
    photo: null,
  },
];

const WorkshopCard = ({ w, i }) => (
  <Reveal delay={0.05 * (i % 3)} className="h-full">
    <article
      className="group relative h-full rounded-2xl glass-static p-6 sm:p-7 flex flex-col transition-all duration-500 hover:-translate-y-1 hover:border-white/25"
      data-testid={`workshop-card-${i}`}
    >
      <span className="flex items-center gap-2.5" data-testid={`workshop-label-${i}`}>
        <span className="h-[3px] w-5 rounded-full bg-gradient-to-r from-[#E3B23C] to-[#F5D06F] transition-all duration-500 group-hover:w-9" />
        <span className="font-display font-extrabold uppercase text-[13px] bg-gradient-to-r from-[#E3B23C] to-[#F5D06F] bg-clip-text text-transparent">
          Workshop
        </span>
      </span>
      <h3 className="mt-3.5 font-display font-bold text-white text-[15px] sm:text-base leading-snug flex-1">
        {w.title}
      </h3>
      <div className="mt-6 pt-4 border-t border-white/[0.08] flex items-center gap-3">
        {w.photo ? (
          <img
            src={w.photo}
            alt={w.host}
            loading="lazy"
            decoding="async"
            className="h-10 w-10 rounded-full object-cover object-top ring-1 ring-white/20 transition-all duration-300 group-hover:ring-[#E3B23C]/60"
          />
        ) : (
          <span className="h-10 w-10 rounded-full border border-dashed border-white/20 bg-white/[0.04] flex items-center justify-center font-display font-bold text-white/40 text-sm">
            ?
          </span>
        )}
        <span className="text-sm text-brand-silver/80" data-testid={`workshop-host-${i}`}>
          {w.host}
        </span>
      </div>
    </article>
  </Reveal>
);

export default function Workshops() {
  return (
    <section id="workshops" className="relative py-20 sm:py-28 overflow-hidden" data-testid="workshops-section">
      <div className="absolute inset-0 bg-[radial-gradient(900px_480px_at_15%_15%,rgba(0,142,255,0.08),transparent_60%)] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-12 sm:mb-16 max-w-3xl">
          <h2 className="heading-lg" data-testid="workshops-heading">
            <MaskLine inView>
              Workshops <span className="text-gradient-blue">inéditos</span>
            </MaskLine>
            <MaskLine inView delay={0.12}>
              na programação do <span className="text-gradient-blue">PS27</span>
            </MaskLine>
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-5 text-white/60 text-sm sm:text-base leading-relaxed" data-testid="workshops-subheading">
              <strong className="text-white font-bold">9 imersões práticas</strong> em 3 salas
              simultâneas. Você traz o caso real e sai com a decisão pronta.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 items-stretch" data-testid="workshops-grid">
          {WORKSHOPS.map((w, i) => (
            <WorkshopCard key={i} w={w} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
